// extracted by mini-css-extract-plugin
export default {"units":"UaoLm","lesson":"mTAXJ","goals":"tFQiy","contents":"_6yZzL","examples":"d2oIN"};